import React, { FC, useState } from "react";
import CreateSolutionModal from "./CreateSolutionModal";
import TickIcon from "../../assets/icons/Icon_Library/application icons/general/tick_circled.svg2";
import MyIcon from "../Common/MyIcon";
import SolutionInfoModal from "../Solutions/SolutionInfoModal";
import SolutionModal from "../Solutions/SolutionOptionsModal";
import SolutionTestModal from "../Solutions/SolutionTestModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClipboard,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import {
  useGetSolutionsQuery,
  SolutionClientType,
  SolutionType,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import DescriptionModal from "./DescriptionModal";
import { Collapse } from "react-bootstrap";

const text = `Monitor staff and stakeholders ensuring their safety and your
          organisations duty of care compliance. 
          This workflow gives you a tool to monitor your own and 3rd party networks, services and connected
          equipment and manage any failures. Quietly listening and reacting to a
          failed ping or received alert, Logic will identify and pick off the
          workflow that you need to deal with the specific event and see it
          through to its conclusion.`;

interface SolutionCardProps {
  solution: SolutionType;
  clientSolution?: SolutionClientType;
}

export const SolutionCard: FC<SolutionCardProps> = ({
  solution: p,
  clientSolution,
}) => {
  const isPurchased = !!clientSolution;
  const description = clientSolution?.Description || p.Description || text;
  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <div
      className={`${
        isPurchased ? "bg-white" : "card-light-gradient"
      } rounded-4 text-navy p-4 position-relative d-flex flex-column h-100`}
    >
      <div>
        <div className=" align-items-start">
          <div>
            <div className="d-flex justify-content-between align-items-center gap-3 ">
              <h3 className="fw-bold m-0 w-50">
                {clientSolution?.SolutionName || p.Label || p.Uuid?.slice(0, 5)}
              </h3>
              {isPurchased && (
                <div className="d-flex justify-content-between align-items-center gap-3 w-50">
                  <div className=" text-secondary"> Running for:</div>
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    {(() => {
                      const now = new Date();
                      const createdDate = new Date(
                        clientSolution!.CreatedAt * 1000
                      );
                      const diffMs = now.getTime() - createdDate.getTime();

                      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
                      const hours = Math.floor(
                        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                      );
                      const minutes = Math.floor(
                        (diffMs % (1000 * 60 * 60)) / (1000 * 60)
                      );

                      if (days === 0 && hours === 0 && minutes === 0) {
                        return (
                          <span className="fw-bold text-navy">Just now</span>
                        );
                      }

                      return (
                        <>
                          <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                            <div className="text-navy fw-bold">{days}</div>
                            <div className="fw-bold">days</div>
                          </span>
                          <span className="fw-bold">:</span>
                          <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                            <div className="text-navy fw-bold">{hours}</div>
                            <div className="fw-bold">hrs</div>
                          </span>
                          <span className="fw-bold">:</span>
                          <span className="bg-icon rounded-2 p-1 d-flex flex-column justify-content-center align-items-center">
                            <div className="text-navy fw-bold">{minutes}</div>
                            <div className="fw-bold">mins</div>
                          </span>
                        </>
                      );
                    })()}
                  </div>{" "}
                </div>
              )}
            </div>
            <div className="position-relative">
              <div className="d-flex gap-3 my-2">
                <div className="w-50">
                  <div className="text-secondary">Created by: {p.Email}</div>
                  <div className="text-secondary">
                    Created at:
                    {new Date(p.CreatedAt * 1000).toLocaleString([], {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </div>
                  <div className="text-secondary">
                    Industry: {p.TagsMap?.industry?.join(", ") || "N/A"}
                  </div>
                  <div className="text-secondary">
                    Category: {p.TagsMap?.category?.join(", ") || "N/A"}
                  </div>
                  <div className=" text-secondary">
                    Version: {p.Version || "N/A"}{" "}
                  </div>
                  <div className="text-secondary">
                    Components used:
                    {p.Components?.length
                      ? p.Components.map((c) => c.Role).join(", ")
                      : " N/A"}
                  </div>
                </div>
                <div className="w-50">
                  {clientSolution && (
                    <div className="text-secondary d-flex align-items-center gap-1">
                      Boom Ref:
                      <div
                        style={{ width: 50 }}
                        className="d-inline-block text-truncate"
                      >
                        {clientSolution.Uuid}
                      </div>
                      <button
                        type="button"
                        className="btn"
                        onClick={async (e) => {
                          e.stopPropagation();
                          await navigator.clipboard.writeText(clientSolution.Uuid);
                          toast.success("Copied to clipboard");
                        }}
                      >
                        <FontAwesomeIcon icon={faCopy} />
                      </button>
                    </div>
                  )}
                  <div className=" text-secondary">
                    {clientSolution
                      ? clientSolution.Reference
                        ? `Ref: ${clientSolution.Reference}`
                        : <br />
                      : p.Reference
                      ? `Ref: ${p.Reference}`
                      : <br />}
                  </div>
                  <div className=" text-secondary">
                    Status : {p.Status || "N/A"}{" "}
                  </div>
                  <div>
                    <div className=" text-secondary ">
                      Kind: {p.Kind || "N/A"}
                    </div>

                    {clientSolution && (
                      <div className=" text-secondary">
                        {clientSolution.WasDeployed ? "Deployed" : "Not Deployed"}
                      </div>
                    )}
                  </div>{" "}
                </div>
              </div>
              <hr className="text-secondary mb-1" />

              <div
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  if (!isPurchased) {
                    setCollapsed(true);
                  }
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  if (!isPurchased) {
                    setCollapsed(false);
                  }
                }}
              >
                <div onClick={(e) => e.stopPropagation()}>
                  {description.split(" ").slice(0, 20).join(" ") + "..."}
                </div>

                <div
                  className="position-absolute bottom-0 overflow-auto p-0 bg-white rounded-3"
                  style={{ maxHeight: "100%" }}
                >
                  <Collapse in={collapsed}>
                    <div className="">
                      <div
                        className=" text-secondary my-2 text-break p-2"
                        style={{
                          // maxHeight: "260px",
                          overflowY: "auto",
                        }}
                      >
                        <div>{description}</div>
                      </div>

                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="d-flex justify-content-center"
                      >
                        <DescriptionModal />
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1"></div>
      {clientSolution?.WasDeployed && (
        <div className="d-flex justify-content-end mb-2">
          <SolutionTestModal solution={p} clientSolution={clientSolution} />
        </div>
      )}
      <div
        className={`${
          isPurchased ? "card-light-gradient" : "bg-white"
        } py-2 row justify-content-evenly rounded-3 `}
      >
        <div className="col-4 border-end">
          <div className="text-center px-3">
            <h5 className="fw-bold text-navy m-0">
              {p.Components?.length || 0}
            </h5>
            <div className="fw-bold text-black" style={{ fontSize: "0.6rem" }}>
              PROJECTS
            </div>
          </div>
        </div>
        <div className="col-4 border-end">
          <div className="text-center px-3">
            <h5 className="fw-bold text-navy m-0">4 </h5>
            <div className="fw-bold text-black" style={{ fontSize: "0.6rem" }}>
              ACTIONS
            </div>
          </div>
        </div>
        <div className="col-4">
          {!isPurchased && (
            <div className="text-center px-3 ">
              <h5 className="fw-bold text-navy m-0">£50</h5>
              <div
                className="fw-bold text-black"
                style={{ fontSize: "0.6rem" }}
              >
                PRICE
              </div>
            </div>
          )}
          {clientSolution && (
            <div className="text-center px-3 d-flex align-items-center gap-1">
              <div>
                <div
                  className="fw-bold text-black"
                  style={{ fontSize: "0.6rem" }}
                >
                  PUBLISH DATE
                </div>
                <div
                  className="fw-bold text-black mt-1"
                  style={{ fontSize: "0.6rem" }}
                >
                  {` ${new Date(clientSolution.CreatedAt * 1000).toLocaleString([], {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}`}
                </div>
              </div>
              <MyIcon Icon={TickIcon} width={15} className="ms-2" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

interface SolutionsCardListProps {
  filters: Record<string, any>;
}

interface SolutionsResponse {
  solutions: SolutionType[];
  total: number;
}

interface SolutionInstanceCard {
  solution: SolutionType;
  clientSolution?: SolutionClientType;
  key: string;
}

const SolutionsCardList: FC<SolutionsCardListProps> = ({ filters }) => {
  const [pagination, setPagination] = useState<{
    limit: number;
    offset: number;
  }>({
    limit: 5,
    offset: 0,
  });
  const res = useGetSolutionsQuery({ ...filters, ...pagination });
  const solutionsData = res.data as SolutionsResponse | undefined;
  const total = solutionsData?.total || 0;

  const solutionInstances: SolutionInstanceCard[] = (
    solutionsData?.solutions || []
  ).flatMap<SolutionInstanceCard>((solution) => {
    const clientSolutions = solution.ClientSolutions || [];
    const purchasedInstances = clientSolutions.map((clientSolution) => ({
      solution,
      clientSolution,
      key: clientSolution.Uuid,
    }));

    if (filters.purchased === "yes") {
      return purchasedInstances;
    }

    return [{ solution, key: `template-${solution.Uuid}` }];
  });

  const [isSelected, setIsSelected] = useState<Record<string, boolean>>({});

  return (
    <div className="d-flex gap-3">
      {solutionInstances.map(({ solution, clientSolution, key }) => (
        <div className="pb-3 h-100" key={key} style={{ width: 600 }}>
          <div className={`my-2 h-100 ${isSelected[key] ? "" : ""} `}>
            <div
              role="button"
              className={`w-100 h-100 p-0 rounded-4 text-start position-relative ${
                isSelected[key] ? "border border-2 border-blue" : ""
              }`}
              onClick={() =>
                setIsSelected((prev) => ({ ...prev, [key]: !prev[key] }))
              }
            >
              {isSelected[key] ? (
                <FontAwesomeIcon
                  icon={faCheck}
                  className="position-absolute top-0 end-0 text-white bg-colored p-2"
                  style={{ borderBottomLeftRadius: 8 }}
                />
              ) : null}
              <div
                className="h-100"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <SolutionInfoModal
                  solution={solution}
                  clientSolution={clientSolution}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
      {solutionsData?.solutions && solutionsData.solutions.length < total && (
        <div className="d-flex align-items-center justify-content-center">
          <button
            type="button"
            className="btn bg-colored text-white rounded-3 fw-bold"
            onClick={() =>
              setPagination((prev) => ({
                ...prev,
                limit: prev.limit + 5,
              }))
            }
          >
            Load more
          </button>
        </div>
      )}
    </div>
  );
};

export default SolutionsCardList;
